import React from "react";

const TrustBox = (props) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  let trustPilotRetries = 3;

  function loadTrustpilotScript() {
    if (window.Trustpilot) {
      trustPilotRetries = 3;
      window.Trustpilot.loadFromElement(ref.current, true);
    } else if (trustPilotRetries) {
      // sometimes it takes a moment for the Trustpilot script to load
      setTimeout(() => {
        trustPilotRetries--;
        loadTrustpilotScript();
      }, 50);
    }
  }
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    loadTrustpilotScript();
  }, []);
  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="5d4c55640218d10001ce4c2d"
      data-style-height="40px"
      data-style-width="200px"
      data-theme="light"
      data-text-color="#1e2347"
      {...props}
      style={{
        position: "relative",
        left: "-9px",
        ...props.style,
        height: "40px",
      }}
    >
      <a
        href="https://www.trustpilot.com/review/gokick.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        Trustpilot
      </a>
    </div>
  );
};
export default TrustBox;
